/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1TaxoparkWithdrawalSecretModel } from '../../entities/v1/TaxoparkWithdrawalSecretModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1TaxoparkWithdrawalSecretModelSchema = z.object({
  company_id: z.string(),
  created_at: z.string().optional(),
  is_api_key_active: z.boolean(),
  is_company_linked: z.boolean(),
  masked_api_key: z.string().optional(),
  provider_id: z.number().int(),
  provider_name: z.string(),
}) as unknown as ToZod<V1TaxoparkWithdrawalSecretModel>